/*
 * @Description:政策文件
 * @Author: lz
 * @Date: 2021-04-29 10:17:37
 * @LastEditTime: 2021-06-25 18:37:26
 * @LastEditors: lz
 */
import request from "@/utils/request";
/**
 * @description
 * @param {string}
 * @returns {string}
 */
export function outerList(data) {
  return request({
    url: "/news/outer/list",
    method: "post",
    data,
  });
}
/**
 * @description 获取北京市
 * @param {string}
 * @returns {string}
 */
export function listTreeCityOnlyBeijing(data) {
  return request({
    url: "/area/listTreeCityOnlyBeijing",
    method: "get",
    data,
  });
}

/**
 * @description 获取全部城市(地级市)列表
 * @param {string}
 * @returns {string}
 */
export function listTreeCity(data) {
  return request({
    url: "/area/listTreeCity",
    method: "get",
    data,
  });
}
/**
 * @description 获取政策文件类型
 * @param {string}
 * @returns {string}
 */
export function typeList(data) {
  return request({
    url: "/news/typeList",
    method: "get",
    data,
  });
}
/**
 * @description 获取政策区域列表
 * @param {string}
 * @returns {string}
 */
export function listPolicyAreasList(data) {
  return request({
    url: "/area/listPolicyAreas",
    method: "post",
    data,
  });
}
/**
 * @description 获取政策文件详情
 * @param {string}
 * @returns {string}
 */
export function outerDetail(data) {
  return request({
    url: "/news/outer/id",
    method: "post",
    data,
  });
}
// export function outerTmpDetail(data) {
//   return request({
//     url: "/news/outer/tmp/id",
//     method: "post",
//     data,
//   });
// }

/**
 * @description 查看是否收藏
 * @param {string}
 * @returns {string}
 */
export function checkColle(data) {
  return request({
    url: "/statistics/checkColle",
    method: "post",
    data,
  });
}
/**
 * @description 收藏
 * @param {string}
 * @returns {string}
 */
export function addColle(data) {
  return request({
    url: "/statistics/addColle",
    method: "post",
    data,
  });
}
/**
 * @description 取消收藏
 * @param {string}
 * @returns {string}
 */
export function cancelColle(data) {
  return request({
    url: "/statistics/cancelColle",
    method: "post",
    data,
  });
}
